import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import {
  Alert,
  Button,
  Checkbox,
  Col,
  Form,
  Image,
  Input,
  Popconfirm,
  Radio,
  Row,
  Space,
  Table,
  Tabs,
  Typography,
} from 'antd'
import { PrimaryButton } from 'Components/button'
import {
  ProductImportVerify,
  ProductImportCreate,
  ImportFileProductCheckingReq,
  ImportFileProductReq,
} from 'Store/product/types'
import {
  selectActionEvent,
  selectCheckingProductsEvent,
  selectCheckingProducts,
  selectImportProductEvent,
} from 'Store/product/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { AppCategory, AppSelect } from 'Components/form'
import EventModal from 'Components/modal/EventModal'
import { clearChunkEventAction, clearEventAction } from 'Store/product/actions'
// import LoadingView from 'Components/modal/LoadingView'
import { DetailDrawer } from 'Components/common/MainLayout'
import styled from 'styled-components'
import { CheckOutlined, CloseOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { MyTheme } from 'Components/common/Theme'
import { ImageFallback } from 'helpers/constanst'
import { ConfirmDailog, ProgressEventModal } from 'Components/modal'
import { cloneDeep } from 'lodash'
import { Data as CateData } from 'Store/categories/types'
import { Data as UomData } from 'Store/uom/types'
import { Data as ManufactuerData } from 'Store/manufactuer/types'
import { findName, findResult, getMenuSelect, isFormError, isFormRequired } from 'helpers/format'
import { checkingProductFromFileAPI, createProductFromFileAPI } from 'Store/product/api'
import { appConfig } from 'config'
import { sortingByNumber } from 'helpers/sorting'
const { TabPane } = Tabs
interface MasterData {
  categories?: CateData[]
  uoms?: UomData[]
  manufacturers?: ManufactuerData[]
}

interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean
  dataIndex: string
  title: any
  inputType: 'number' | 'text'
  record: any
  index: number
  children: React.ReactNode
}

type Props = ReduxProps & {
  visible: boolean
  onCloseDrawer: () => void
  onSuccess?: () => void
  productData: ProductImportVerify[]
  masterData?: MasterData
}

const ImportProductFromExcel: React.FunctionComponent<Props> = props => {
  const {
    onCloseDrawer,
    visible,
    currentUser,
    event,
    onSuccess = () => {},
    dataList,
    detailEvent,
    productData,
    masterData,
  } = props

  // const datas = productData
  const successData = dataList?.data?.ok || []
  const duplicateData = dataList?.data?.dup || []

  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 20,
  })
  const [filter, setFilter] = useState({
    keyword: '',
    merchant_id: 0,
    skip_exists: 0,
  })

  const requireFeild = [
    'photos',
    'code',
    'title',
    'group_id',
    'category_id',
    'sub_category_id',
    'manufacturer_id',
    'uom_id',
    'details',
    'warranty_status',
    'product_warranty_unit',
    'refund_status',
    'product_refund_unit',
    'shipping_types',
    'product_options',
  ]

  const [selectProduct, setSelectProduct] = useState([] as ProductImportVerify[])
  const [confirmImportDailog, setConfirmImportDailog] = useState(false)
  const [formData, setFormData] = useState([] as ProductImportVerify[])
  const [isLoading, setIsLoading] = useState(false)
  const [formError, setFormError] = useState([] as string[])
  const manufactuerMenu = getMenuSelect(masterData?.manufacturers || [])
  const [oldFormData, setOldFormData] = useState([] as ProductImportVerify[])
  const [activeTab, setActiveTab] = useState('success' as string)
  const [editingKey, setEditingKey] = useState('')
  const [mode, setMode] = useState('view' as 'view' | 'edit')
  const [lastRecord, setLastRecord] = useState(0)
  const isEditing = (record: any) => record.key === editingKey
  const dispatch = useDispatch()
  const chunkSize = appConfig.importProductChunkSize || 100
  const [form] = Form.useForm()

  const title = 'เลือกสินค้าที่ต้องการนำเข้า'

  useEffect(() => {
    return () => {
      setSelectProduct([])
      setFormData([])
      setEditingKey('')
      pagination.Page = 1
      pagination.RowPerPage = 20
      setPagination({ ...pagination })
      setMode('view')
      setActiveTab('success')
      setLastRecord(0)
    }
  }, [visible])

  useEffect(() => {
    if (visible && successData) {
      setIsLoading(true)
      setTimeout(() => {
        // const data = successData && successData.slice(11, 20)
        setFormData(cloneDeep(successData))
        setIsLoading(false)
      }, 0.1)
    }
  }, [successData])

  useEffect(() => {
    if (!visible) return
    if (currentUser?.accessToken && visible && productData) {
      if (productData.length > 0) {
        onCheckingProduct(productData)
      }
    }
  }, [productData])

  const findProductInfo = (id: number) => {
    return formData && formData.find(item => item.id === id)
  }

  const formatImportReq = (products: ProductImportVerify[]) => {
    const req = [] as ProductImportCreate[]
    products &&
      products.forEach((record: ProductImportVerify, index: number) => {
        const formProduct = findProductInfo(record.id)
        req.push({
          activated: record.activated,
          area: record.area,
          barcode: record.barcode,
          bound_id: record.bound_id,
          category_id: formProduct?.category_id || 0,
          code: record.code,
          deliver_status: record.deliver_status,
          details: record.details,
          enable_discount: record.enable_discount,
          first_update: record.first_update,
          group_id: formProduct?.group_id || 0,
          height: record.height,
          instruction: record.instruction,
          lat: record.lat,
          length: record.length,
          long: record.long,
          maintenant_and_caution: record.maintenant_and_caution,
          manual: record.manual,
          manufacturer_id: formProduct?.manufacturer_id || 0,
          master_id: record.master_id,
          max_distance: record.max_distance,
          merchant_id: record.merchant_id,
          model: record.model,
          offline_price: record.offline_price,
          //offline_price: index === 6 ? 'test-error' : record.offline_price,
          online_percentage: record.online_percentage,
          photo: record.photo,
          photos: record.photos,
          price: record.price,
          price_a: record.price_a,
          price_b: record.price_b,
          price_c: record.price_c,
          product_option_title: record.product_option_title,
          product_refund_unit: record.product_refund_unit,
          product_warranty: record.product_warranty,
          product_warranty_unit: record.product_warranty_unit,
          products: record.products,
          properties: record.properties,
          quantity: record.quantity,
          quantity_offline: record.quantity_offline,
          refund_status: record.request_status,
          request_status: record.request_status,
          shipping_types: record.shipping_types,
          slug: record.slug,
          status: record.status,
          status_pos: record?.status_pos,
          sub_category_id: formProduct?.sub_category_id || 0,
          tags: record.tags,
          title: record.title,
          uom_id: formProduct?.uom_id || 0,
          warranty_status: record.warranty_status,
          weight: record.weight,
          width: record.width,
          free_shipping: record.free_shipping,
          master_product: record.master_product,
          product_refund: record.product_refund,
        })
      })
    return req
  }

  const getChunkData = (selectProduct: ProductImportVerify[]) => {
    const chunks = [] as { start: number; end: number }[]
    for (let i = 0; i < selectProduct.length; i += chunkSize) {
      const chunk = selectProduct.slice(i, i + chunkSize)
      // do whatever
      chunks.push({ start: chunk[0].id, end: chunk[chunk.length - 1].id })
    }
    return chunks
  }

  const chuckImport = (productData: ProductImportCreate[]) => {
    const start = lastRecord
    const end = start + chunkSize
    setLastRecord(end)
    const chunk = productData.slice(start, end)
    return chunk
  }

  const onImport = (): void => {
    const chunkData = chuckImport(formatImportReq(selectProduct))
    const req: ImportFileProductReq = {
      products: chunkData,
    }
    dispatch(createProductFromFileAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onCheckingProduct = (productData: ProductImportVerify[]): void => {
    const req: ImportFileProductCheckingReq = {
      products: productData,
    }
    dispatch(
      checkingProductFromFileAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''),
    )
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
  }

  const onEventSuccess = (): void => {
    if (lastRecord >= selectProduct.length) {
      clearEvent()
      onSuccess()
    } else {
      dispatch(clearChunkEventAction())
      onImport()
    }
  }

  const onCheckingSuccess = (): void => {
    clearEvent()
  }

  const onFilter = (key: string, val: any) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const isSelect = (record: ProductImportVerify) => {
    const found = selectProduct.find(item => item.id === record.id)
    return found ? true : false
  }

  const removeID = (record: ProductImportVerify) => {
    return selectProduct.filter(item => item.id !== record.id)
  }

  const isSelectAll = formData.length == selectProduct.length

  const onSelectAll = () => {
    if (isSelectAll) {
      setSelectProduct([])
    } else {
      const selecData = formData.filter(item => item.isValidCate && item.isValidManu && item.isValidUom)
      setSelectProduct([...selecData])
    }
  }

  const onUnSelectAll = () => {
    setSelectProduct([])
  }

  const onSelectProduct = (record: ProductImportVerify) => {
    setIsLoading(true)
    let newSelect = selectProduct
    if (isSelect(record)) {
      newSelect = removeID(record)
    } else {
      newSelect.push(record)
    }
    setSelectProduct([...newSelect])
    setIsLoading(false)
  }

  const onConfirmImport = () => {
    onImport()
    onCloseConfirmImport()
  }

  const onOpenConfirmImport = () => {
    setConfirmImportDailog(true)
  }

  const onCloseConfirmImport = () => {
    setConfirmImportDailog(false)
  }

  const renderImage = (img: string[]) => (
    <ThumbImage src={appConfig.assetCdnEndpoint + img[0]} fallback={ImageFallback} />
  )

  const validateCategory = (record: ProductImportVerify) => {
    const name = [] as string[]
    const group = findResult(record?.group_id, masterData?.categories || [])
    if (!group) {
      return false
    }
    if (group) {
      name.push(group?.name || '')
      const cate = findResult(record?.category_id, (group && group.child) || [])
      if (!cate) {
        return false
      }
      if (cate) {
        name.push(cate?.name || '')
        const subCate = findResult(record?.sub_category_id, (cate && cate.child) || [])
        if (!subCate) {
          return false
        }
      }
    }
    return true
  }

  const validateManufacturer = (record: ProductImportVerify) => {
    const manu = findResult(record?.manufacturer_id, masterData?.manufacturers || [])
    return manu ? true : false
  }

  const validateUom = (record: ProductImportVerify) => {
    const manu = findResult(record?.uom_id, masterData?.uoms || [])
    return manu ? true : false
  }

  const renderCategoryInfo = (group: any, record: ProductImportVerify) => {
    const result = findCatName(record?.group_id, record?.category_id, record?.sub_category_id)
    return (
      <>
        {result.join('/')}
        {activeTab === 'success' && !record.isValidCate && (
          <WarningText>*ข้อมูลหมวดหมู่ไม่ถูกต้อง</WarningText>
        )}
      </>
    )
  }

  const renderManuInfo = (group: any, record: ProductImportVerify) => {
    const result = findName(record.manufacturer_id, masterData?.manufacturers || [])
    return (
      <>
        {result}
        {activeTab === 'success' && !record.isValidManu && <WarningText>*ข้อมูลยี่ห้อไม่ถูกต้อง</WarningText>}
      </>
    )
  }

  const renderUomInfo = (group: any, record: ProductImportVerify) => {
    const result = findName(record.uom_id, masterData?.uoms || [])
    return (
      <>
        {result}
        {activeTab === 'success' && !record.isValidUom && <WarningText>*ข้อมูลหน่วยไม่ถูกต้อง</WarningText>}
      </>
    )
  }

  const renderActionButton = (id: number, record: ProductImportVerify) => {
    const dataInvalid = !record?.isValidCate || !record?.isValidManu || !record?.isValidUom
    return (
      <Space size="small" wrap={true} direction="vertical">
        <Checkbox
          onChange={() => onSelectProduct(record)}
          checked={isSelect(record)}
          disabled={editingKey !== '' || dataInvalid || mode === 'edit'}
        />
      </Space>
    )
  }

  const onEdit = (record: any & { key: React.Key }) => {
    form.setFieldsValue({ ...record })
    setEditingKey(record.key)
    setOldFormData(cloneDeep(formData))
  }

  const onCancel = () => {
    setEditingKey('')
    setFormData(cloneDeep(oldFormData))
  }

  const onDelete = (id: number) => {
    setIsLoading(true)
    const newData = cloneDeep(formData).filter(item => item.id !== id)
    const newSelect = cloneDeep(selectProduct).filter(item => item.id !== id)
    setFormData([...newData])
    setSelectProduct([...newSelect])
    setIsLoading(false)
  }

  const onSave = () => {
    setEditingKey('')
  }

  const renderEditButton = (_: any, record: ProductImportVerify) => {
    if (mode === 'view') {
      return <span></span>
    }

    const editable = record.key === editingKey
    return editable ? (
      <Space direction="horizontal" size={'middle'}>
        <SaveTypographyText onClick={onSave} style={{ marginRight: 8 }}>
          <CheckOutlined /> บันทึก
        </SaveTypographyText>
        <CancleTypographyText onClick={onCancel}>
          <CloseOutlined /> ยกเลิก
        </CancleTypographyText>
        {/* <Popconfirm title="แน่ใจหรือไม่ที่จะยกเลิก?" onConfirm={onCancel} okText="ใช่" cancelText="ไม่">
          <CancleTypographyText>
            <CloseOutlined /> ยกเลิก
          </CancleTypographyText>
        </Popconfirm> */}
      </Space>
    ) : (
      <Space direction="horizontal" size={'middle'}>
        <TypographyText disabled={editingKey !== ''} onClick={() => onEdit(record)}>
          <EditOutlined /> แก้ไข
        </TypographyText>
        {editingKey === '' && (
          <Popconfirm
            disabled={editingKey !== ''}
            title="แน่ใจหรือไม่ที่จะลบ"
            onConfirm={() => onDelete(record?.id || 0)}
            okText="ใช่"
            cancelText="ไม่"
          >
            <CancleTypographyText>
              <DeleteOutlined /> ลบ
            </CancleTypographyText>
          </Popconfirm>
        )}
      </Space>
    )
  }

  const findCatName = (group_id: number, category_id: number, sub_category_id: number) => {
    const name = [] as string[]
    const group = findResult(group_id, masterData?.categories || [])
    if (group) {
      name.push(group?.name || '')
      const cate = findResult(category_id, (group && group.child) || [])
      if (cate) {
        name.push(cate?.name || '')
        const subCate = findResult(sub_category_id, (cate && cate.child) || [])
        name.push(subCate?.name || '')
      }
    } else {
      name.push('')
    }
    return name
  }

  const onChangeCategories = (value: any, id: number) => {
    const data = formData.map(record => {
      if (record.id === id) {
        record.group_id = value[0] ? value[0] : 0
        record.category_id = value[1] ? value[1] : 0
        record.sub_category_id = value[2] ? value[2] : 0
        record.isValidCate = true
      }
      return record
    })
    setFormData([...data])
  }

  const onChangeManufacturer = (value: any, id: number) => {
    const data = formData.map(record => {
      if (record.id === id) {
        record.manufacturer_id = value
        record.isValidManu = true
      }
      return record
    })
    setFormData([...data])
  }

  const onChangeUom = (value: any, id: number) => {
    const data = formData.map(record => {
      if (record.id === id) {
        record.uom_id = value
        record.isValidUom = true
      }
      return record
    })
    setFormData([...data])
  }

  const isRequired = (name: string) => {
    return isFormRequired(requireFeild, name)
  }

  const isError = (name: string) => {
    return isFormError(formError, name)
  }

  const getCategoriesValue = (formData: ProductImportVerify) => {
    const value = []
    if (formData?.group_id) {
      value.push(formData?.group_id)
    }
    if (formData?.category_id) {
      value.push(formData?.category_id)
    }
    if (formData?.sub_category_id) {
      value.push(formData?.sub_category_id)
    }
    return value
  }

  const renderCategoryForm = (val: any, record: ProductImportVerify, index: number) => {
    return (
      <AppCategory
        label=""
        isRequired={isRequired('group_id')}
        isError={isError('group_id') || isError('category_id') || isError('sub_category_id')}
        categories={masterData?.categories || []}
        name="group_id"
        onChange={val => onChangeCategories(val, record.id)}
        value={getCategoriesValue(record)}
        changeOnSelect={false}
        key={index}
        allowClear={false}
      />
    )
  }

  const renderManufacturer = (val: any, record: ProductImportVerify, index: number) => {
    return (
      <AppSelect
        name="manufacturer_id"
        label=""
        isRequired={isRequired('manufacturer_id')}
        isError={isError('manufacturer_id')}
        value={record?.manufacturer_id || 0}
        onChange={val => onChangeManufacturer(val, record.id)}
        menu={manufactuerMenu}
        key={index}
        allowClear={false}
      />
    )
  }

  const renderUom = (val: any, record: ProductImportVerify, index: number) => {
    return (
      <AppSelect
        name="uom_id"
        label=""
        isRequired={isRequired('uom_id')}
        isError={isError('uom_id')}
        value={record?.uom_id || 0}
        onChange={val => onChangeUom(val, record.id)}
        menu={getMenuSelect(masterData?.uoms || [])}
        key={index}
        allowClear={false}
      />
    )
  }

  const validateData = (datas: ProductImportVerify[]): ProductImportVerify[] => {
    const newdata =
      datas &&
      datas.map((record: ProductImportVerify) => {
        // const validateCate = validateCategory(record)
        record.isValidCate = validateCategory(record)
        record.isValidManu = validateManufacturer(record)
        record.isValidUom = validateUom(record)
        return record
      })
    return newdata
  }

  const duplicateColumns = [
    {
      title: 'แถว',
      dataIndex: 'id',
      key: 'id',
      width: '50px',
      render: (val: number) => val,
    },
    // {
    //   title: 'รูปภาพ',
    //   dataIndex: 'photos',
    //   key: 'photos',
    //   render: renderImage,
    //   width: '80px',
    // },
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'title',
      key: 'title',
    },

    {
      title: 'หมวดหมู่สินค้า',
      dataIndex: 'group_id',
      key: 'group_id',
      width: '300px',
      editable: true,
      render: renderCategoryInfo,
    },
    {
      title: 'ยี่ห้อ',
      dataIndex: 'manufacturer_id',
      key: 'manufacturer_id',
      width: '150px',
      editable: true,
      render: renderManuInfo,
    },
    {
      title: 'หน่วย',
      dataIndex: 'uom_id',
      key: 'uom_id',
      width: '150px',
      editable: true,
      render: renderUomInfo,
    },
  ]

  const columns = [
    {
      title: 'เลือก',
      dataIndex: 'action',
      key: 'action',
      render: renderActionButton,
      width: '50px',
    },
    // {
    //   title: 'ลำดับ/แถว',
    //   dataIndex: 'id',
    //   key: 'id',
    //   width: '100px',
    //   //render: (val: number, index: number) => index + 1,
    //   render: (val: number, record: any, index: number) => `${index + 1}/${val}`,
    // },
    {
      title: 'แถว',
      dataIndex: 'id',
      key: 'id',
      width: '50px',
      render: (val: number) => val,
    },
    // {
    //   title: 'รูปภาพ',
    //   dataIndex: 'photos',
    //   key: 'photos',
    //   render: renderImage,
    //   width: '80px',
    // },
    {
      title: 'ชื่อสินค้า',
      dataIndex: 'title',
      key: 'title',
    },

    {
      title: 'หมวดหมู่สินค้า',
      dataIndex: 'group_id',
      key: 'group_id',
      width: '300px',
      editable: true,
      render: renderCategoryInfo,
    },
    {
      title: 'ยี่ห้อ',
      dataIndex: 'manufacturer_id',
      key: 'manufacturer_id',
      width: '150px',
      editable: true,
      render: renderManuInfo,
    },
    {
      title: 'หน่วย',
      dataIndex: 'uom_id',
      key: 'uom_id',
      width: '150px',
      editable: true,
      render: renderUomInfo,
    },
    {
      title: '',
      dataIndex: 'operation',
      width: mode === 'edit' ? '180px' : '0px',
      render: renderEditButton,
    },
  ]

  const invalidData =
    formData && formData.filter(record => !record?.isValidCate || !record?.isValidManu || !record?.isValidUom)

  const onChangeMode = () => {
    setMode(mode === 'edit' ? 'view' : 'edit')
    setEditingKey('')
  }

  const ButtonGroup = (
    <FilterWrapper>
      <Row justify="space-between" align="bottom" gutter={[16, 16]}>
        {formData.length > 0 && (
          <Col span={24}>
            <Row justify="space-between" gutter={[16, 16]}>
              <Col>
                {/* <Button
                  onClick={onSelectAll}
                  size="large"
                  icon={<Checkbox value={2} checked={isSelectAll}></Checkbox>}
                  style={{ borderRadius: '5px' }}
                  disabled={mode === 'edit'}
                >
                  &nbsp; เลือกทั้งหมด
                </Button> */}
                <PrimaryButton
                  icon={<Checkbox value={2} checked={isSelectAll}></Checkbox>}
                  text={<span>&nbsp; {isSelectAll ? 'เอาออกทั้งหมด' : 'เลือกทั้งหมด'}</span>}
                  onClick={onSelectAll}
                  btnType={'Primary'}
                  key="select-all"
                  disabled={mode === 'edit'}
                ></PrimaryButton>
              </Col>
              <Col>
                <PrimaryButton
                  text={`${mode === 'edit' ? 'แก้ไขข้อมูลสำเร็จ' : 'แก้ไขข้อมูล'}`}
                  onClick={onChangeMode}
                  disabled={editingKey !== ''}
                  size="large"
                  btnType={mode === 'edit' ? 'Approve' : 'Reject'}
                  icon={mode === 'edit' ? <CheckOutlined /> : <EditOutlined />}
                ></PrimaryButton>
              </Col>
            </Row>
          </Col>
        )}
        {invalidData && invalidData.length > 0 && (
          <Col span={24}>
            <Alert
              message={`ตรวจสอบพบข้อมูลไม่ถูกต้อง ${invalidData.length} รายการ`}
              description="ข้อมูลสินค้าที่ไม่ถูกต้องจะไม่สามารถเลือกในการนำเข้าได้ กรุณาแก้ไขข้อมูลให้ถูกต้องก่อนเลือกสินค้าในการนำเข้า"
              type="warning"
              showIcon
            />
          </Col>
        )}
      </Row>
    </FilterWrapper>
  )

  const FooterContent = (
    <Space size="middle" align="baseline">
      <PrimaryButton text="ยกเลิก" btnType="Cancel" onClick={onCloseDrawer} />
      <PrimaryButton
        disabled={selectProduct.length <= 0 || mode === 'edit'}
        text={`นำเข้าสินค้า (${selectProduct.length} รายการ)`}
        onClick={onOpenConfirmImport}
      />
    </Space>
  )

  const ConfirmImport = (
    <ConfirmDailog
      isShow={confirmImportDailog}
      handleOk={onConfirmImport}
      handleCancel={onCloseConfirmImport}
      title="ยืนยันการนำเข้าสินค้า"
      description={`คุณแน่ใจหรือไม่ว่าต้องการนำเข้าสินค้าใหม่ ${selectProduct.length} รายการ?`}
      confirmBtnTxt="นำเข้าสินค้า"
    />
  )

  const mergedColumns =
    columns &&
    columns.map(col => {
      if (!col.editable) {
        return col
      }

      return {
        ...col,
        width: col.width,
        onCell: (record: ProductImportVerify) => ({
          record,
          inputType: 'number',
          dataIndex: col.dataIndex,
          title: col.title,
          editing: isEditing(record),
          col,
        }),
      }
    })

  const EditableCell: React.FC<EditableCellProps> = ({
    editing,
    dataIndex,
    title,
    inputType,
    children,
    record,
    ...restProps
  }) => {
    const inputNode = <Input type={inputType} />

    const getForm = () => {
      switch (dataIndex) {
        case 'group_id':
          return renderCategoryForm('', record, record.id)
        case 'manufacturer_id':
          return renderManufacturer('', record, record.id)
        case 'uom_id':
          return renderUom('', record, record.id)

        default:
          return (
            <Form.Item
              name={dataIndex}
              style={{ margin: 0 }}
              rules={[
                {
                  required: true,
                  message: `กรุณาระบุ ${title}`,
                },
              ]}
            >
              {inputNode}
            </Form.Item>
          )
      }
    }

    return <td {...restProps}>{editing ? getForm() : children}</td>
  }

  const onChangeTab = (key: string): void => {
    setActiveTab(key)
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }

  const getTab = () => {
    return (
      <Tabs defaultActiveKey={'success'} onChange={onChangeTab} type="card" activeKey={activeTab}>
        <TabPane tab={`สินค้าที่สามารถนำเข้าได้ (${formData.length} รายการ)`} key={'success'}>
          {ButtonGroup}
          <Form form={form} component={false}>
            <Table
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              bordered={false}
              dataSource={validateData(formData)}
              columns={mergedColumns}
              rowClassName={(record: ProductImportVerify) =>
                !record?.isValidCate || !record?.isValidManu || !record?.isValidUom ? 'row-warning' : ''
              }
              pagination={false}
              rowKey={'key'}
              size="middle"
              loading={detailEvent.IsLoading || isLoading}
            />
          </Form>
        </TabPane>
        {duplicateData && duplicateData.length > 0 && (
          <TabPane tab={`สินค้าที่ชื่อซ้ำกับข้อมูลในระบบ (${duplicateData.length} รายการ)`} key={'duplicate'}>
            <Table
              bordered={false}
              dataSource={duplicateData}
              columns={duplicateColumns}
              // rowClassName={(record: ProductImportVerify) =>
              //   !record?.isValidCate || !record?.isValidManu || !record?.isValidUom ? 'row-warning' : ''
              // }
              pagination={false}
              rowKey={'key'}
              size="middle"
              loading={detailEvent.IsLoading}
            />
          </TabPane>
        )}
      </Tabs>
    )
  }

  return (
    <DetailDrawer
      width={'90%'}
      title={title}
      onCloseDrawer={onCloseDrawer}
      visible={visible}
      footer={FooterContent}
      maskClosable={false}
    >
      <Wrapper>
        {/* {FilterContent} */}
        {/* <TableListPage
        columns={columns}
        datas={formData}
        isLoading={detailEvent.IsLoading || isLoading}
        paginationContent={null}
        scrollX={800}
        rowKey="id"
        //rowClassName={(record: ProductImportVerify) => (record?.id % 2 == 0 ? 'row-warning' : '')}
      /> */}
        {getTab()}
        <EventModal
          event={[detailEvent]}
          enable={visible}
          successCalback={onCheckingSuccess}
          errorCalback={clearEvent}
        />
        {selectProduct.length <= chunkSize ? (
          <EventModal
            event={[event]}
            enable={visible}
            successCalback={onEventSuccess}
            errorCalback={clearEvent}
          />
        ) : (
          <ProgressEventModal
            event={[event]}
            enable={visible}
            successCalback={onEventSuccess}
            errorCalback={() => {
              clearEvent()
              setLastRecord(0)
              onCheckingProduct(productData)
              setSelectProduct([])
            }}
            success={lastRecord}
            total={selectProduct.length}
            chunkSize={chunkSize}
            chunkData={getChunkData(sortingByNumber(selectProduct, 'asc', 'id'))}
          />
        )}

        {ConfirmImport}
      </Wrapper>
    </DetailDrawer>
  )
}

const ThumbImage = styled(Image)`
  border-radius: 5px;
  width: 60px;
  height: 60px;
  object-fit: cover;
`

const Wrapper = styled.div`
  tr.row-warning td:nth-child(1) {
    border-left: 5px solid ${(props: { theme: MyTheme }): string => props.theme.colors.error};
  }

  .row-warning {
    background-color: #f5222d12;
  }
`

const FilterWrapper = styled.div`
  padding: 0 0 10px 0;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

const WarningText = styled.div`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const TypographyText = styled(Typography.Link)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const SaveTypographyText = styled(Typography.Link)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.success} !important ;
`

const CancleTypographyText = styled(Typography.Link)`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.error} !important ;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectImportProductEvent(state),
    dataList: selectCheckingProducts(state),
    detailEvent: selectCheckingProductsEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(ImportProductFromExcel)
